import FlagLinks from "@/Components/FlagLinks";

require('./bootstrap');

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';


// Fontawesome
import { library } from '@fortawesome/fontawesome-svg-core';

import {
    faHeart as fasHeart,
    faBell as fasBell,
    faCheck as fasCheck,
    faCheckSquare as fasCheckSquare,
    faPlus as fasPlus,
    faArrowUp as fasArrowUp,
    faArrowDown as fasArrowDown,
    faArrowRight as fasArrowRight,
    faArrowLeft as fasArrowLeft,
    faUser as fasUser,
    faLock as fasLock,
    faCircle as fasCircle,
    faKey as fasKey,
    faClock as fasClock,
    faTrash as fasTrash,
    faExternalLink as fasExternalLink,
    faChevronDown as fasChevronDown,
    faUserTimes as fasUserTimes,
    faEnvelopeOpen as fasEnvelopeOpen,
    faPaperPlane as fasPaperPlane,
    faUndoAlt as fasUndoAlt,
    faCaretDown as fasCaretDown,
} from '@fortawesome/pro-solid-svg-icons';

import {
    faArrowUp as farArrowUp,
    faArrowRight as farArrowRight,
    faArrowDown as farArrowDown,
    faArrowLeft as farArrowLeft,
    faBell as farBell,
    faUser as farUser,
    faBuilding as farBuilding,
    faPowerOff as farPowerOff,
    faHeart as farHeart,
    faFilter as farFilter,
    faSquare as farSquare,
    faBullseyePointer as farBullseyePointer,
    faPlusCircle as farPlusCircle,
    faTrash as farTrash,
} from '@fortawesome/pro-regular-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(fasHeart);
library.add(fasBell);
library.add(fasPlus);
library.add(fasCheck);
library.add(fasArrowUp);
library.add(fasArrowRight);
library.add(fasArrowDown);
library.add(fasArrowLeft);
library.add(fasCheckSquare);
library.add(fasLock);
library.add(farSquare);
library.add(farHeart);
library.add(farBell);
library.add(farUser);
library.add(fasUser);
library.add(farPowerOff);
library.add(farBuilding);
library.add(fasCircle);
library.add(fasKey);
library.add(fasClock);
library.add(fasTrash);
library.add(fasExternalLink);
library.add(fasChevronDown);
library.add(farFilter);
library.add(fasUserTimes);
library.add(fasEnvelopeOpen);
library.add(farBullseyePointer);
library.add(fasPaperPlane);
library.add(fasUndoAlt);
library.add(fasCaretDown);
library.add(farPlusCircle);
library.add(farTrash);



import Verte from 'verte';
import 'verte/dist/verte.css';


const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({ el, app, props, plugin }) {
        return createApp({ render: () => h(app, props) })
            .use(plugin)
            .mixin({ methods: { route } })
            .mixin(require('./tools/translate'))
            .component('verte', Verte)
            .component('font-awesome-icon', FontAwesomeIcon )
            .component('flag-links', FlagLinks )
            .mount(el);
    },
});

InertiaProgress.init({ color: '#4B5563' });


localStorage.theme = 'light';

